import supabase from "./supabase"; // Ensure this path is correct

// Fetch settings from the "settings" table
export async function getSettings() {
  const { data, error } = await supabase.from("settings").select("*").single(); // Assuming you're fetching a single row of settings

  if (error) {
    console.error("Error fetching settings:", error);
    throw new Error("Settings could not be loaded");
  }

  return data;
}

// Update settings in the "settings" table
export async function updateSettings(updatedSettings) {
  const { id, ...settingsData } = updatedSettings; // Destructure to separate id from the rest of the settings data
  let data, error;

  if (id) {
    // Update the existing settings
    ({ data, error } = await supabase
      .from("settings")
      .update(settingsData)
      .eq("id", id)
      .select()
      .single());
  } else {
    // If no id is provided, you might want to handle this as an error or insert new settings
    console.error("No ID provided for updating settings");
    throw new Error("Settings ID is required to update");
  }

  if (error) {
    console.error("Error updating settings:", error);
    throw new Error("Could not update settings");
  }

  return data;
}
